
// import React, { useEffect, useState } from "react";
// import {
//   Box,
//   Typography,
//   Button,
//   IconButton,
//   Chip,
//   Modal,
//   List,
//   ListItem,
//   ListItemText,
//   ListItemSecondaryAction,
//   Dialog,
//   DialogActions,
//   DialogContent,
//   DialogContentText,
//   DialogTitle,
//   TextField,
//   CircularProgress,
// } from "@mui/material";
// import {
//   Visibility,
//   CheckCircleOutline,
//   Upload as UploadIcon,
//   Close as CloseIcon,
//   Error as ErrorIcon,
// } from "@mui/icons-material";
// import api from "../../api/axiosInterceptor";
// import { API_BASE_URL } from "../../config";
// import TableComponent from "../../Components/TableComponent/TableComponent";
// import { LoadingSpinner } from "../../Components/spinner/spinner";
// import { SnackBarComponent } from "../../Components/snackBar/snackBar";
// import ClaimFormPage from "./claimForm";
// import ClaimDetailPage from "./claimView";
// import { useTranslation } from "react-i18next";

// export default function ClaimListPage() {
//   const { t } = useTranslation();

//   const [rows, setRows] = useState([]);
//   const [loading, setLoading] = useState(true);
//   const [snackbar, setSnackbar] = useState({
//     open: false,
//     message: "",
//     severity: "info",
//   });
//   const [showForm, setShowForm] = useState(false);
//   const [selectedClaimId, setSelectedClaimId] = useState(null);

//   // Additional Docs Modal states
//   const [additionalDocsModal, setAdditionalDocsModal] = useState({
//     open: false,
//     claimId: null,
//     docs: [],
//     loading: false,
//   });
//   const [editDocModal, setEditDocModal] = useState({
//     open: false,
//     docId: null,
//     claimId: null,
//     file: null,
//     uploading: false,
//   });
//   const [confirmSubmitModal, setConfirmSubmitModal] = useState({
//     open: false,
//     docId: null,
//     claimId: null,
//   });

//   // Success modal states
//   const [successModal, setSuccessModal] = useState({
//     open: false,
//     ack_no: "",
//     message: "",
//   });

//   const showSnackbar = (msg, sev = "info") =>
//     setSnackbar({ open: true, message: msg, severity: sev });
//   const closeSnackbar = () => setSnackbar({ ...snackbar, open: false });

//   const getStatusColor = (status) => {
//     switch (status) {
//       case "Rejected":
//         return "error";
//       case "CA Verified":
//         return "success";
//       case "In Progress":
//         return "warning";
//       case "Submitted":
//         return "info";
//       case "Settled":
//         return "success";
//       case "Draft":
//         return "default";
//       default:
//         return "default";
//     }
//   };

//   const fetchClaims = async () => {
//     setLoading(true);
//     try {
//       const res = await api.get(`/claim-mgmt/claims/`);
//       const data = await Promise.all(
//         res.data.map(async (item, idx) => {
//           const csb = Array.isArray(item.claim_status_base)
//             ? item.claim_status_base[0]
//             : item.claim_status_base;

//           const status = csb
//             ? csb.is_rejected
//               ? "Rejected"
//               : csb.is_settled
//               ? "Settled"
//               : csb.is_ca_verified
//               ? "CA Verified"
//               : csb.is_verified_2 || csb.is_verified_1
//               ? "In Progress"
//               : csb.is_submited
//               ? "Submitted"
//               : "Draft"
//             : "Unknown";

//           // Fetch additional docs for this claim
//           let additionalDocsData = [];
//           try {
//             const docsRes = await api.get(
//               `/claim-mgmt/additional-docs/${item.id}/`
//             );
//             additionalDocsData = docsRes.data || [];
//           } catch (err) {
//             additionalDocsData = [];
//           }

//           return {
//             id: item.id,
//             slNo: idx + 1,
//             // claimant_name: item.name_of_claimant1 || "-",
//             claimant_name:
//               item.claiment_type === "self"
//                 ? item.name_of_claimant1 || "-"
//                 : item.claiment_type === "nominee"
//                 ? item.nominee?.[0]?.name || "-"
//                 : item.claiment_type === "legal_heir"
//                 ? item.legalHeir?.[0]?.name || "-"
//                 : item.name_of_claimant1 || "-",
//             ack_no: item.ack_no || "-",
//             created: item.created
//               ? new Date(item.created).toLocaleDateString("en-GB")
//               : "-",
//             status,
//             additionalDocsData,
//             fullData: item,
//           };
//         })
//       );
//       setRows(data);
//     } catch (err) {
//       console.error("fetchClaims", err);
//       showSnackbar(t("claimList.fetchError"), "error");
//     } finally {
//       setLoading(false);
//     }
//   };

//   const fetchAdditionalDocs = async (claimId) => {
//     try {
//       const res = await api.get(`/claim-mgmt/additional-docs/${claimId}/`);
//       return res.data || [];
//     } catch (err) {
//       console.error("fetchAdditionalDocs", err);
//       return [];
//     }
//   };

//   useEffect(() => {
//     fetchClaims();
//   }, []);

//   const handleAdditionalDocsClick = async (claimId) => {
//     setAdditionalDocsModal((prev) => ({ ...prev, loading: true, claimId }));
//     const docs = await fetchAdditionalDocs(claimId);
//     setAdditionalDocsModal({
//       open: true,
//       claimId,
//       docs,
//       loading: false,
//     });
//   };

//   const handleEditDoc = (docId, claimId) => {
//     setEditDocModal({
//       open: true,
//       docId,
//       claimId,
//     });
//   };

//   const handleFileChange = (e) => {
//     setEditDocModal((prev) => ({ ...prev, file: e.target.files[0] }));
//   };

//   const handleSubmitDoc = async () => {
//     if (!editDocModal.file) {
//       showSnackbar("Please select a file to upload", "warning");
//       return;
//     }

//     setConfirmSubmitModal({
//       open: true,
//       docId: editDocModal.docId,
//       claimId: editDocModal.claimId,
//     });
//   };

//   const confirmSubmit = async () => {
//     setConfirmSubmitModal({ open: false, docId: null, claimId: null });
//     setEditDocModal((prev) => ({ ...prev, uploading: true }));

//     const formData = new FormData();
//     formData.append("document", editDocModal.file);
//     formData.append("is_submited", true);

//     try {
//       await api.patch(
//         `/claim-mgmt/additional-docs/${editDocModal.claimId}/${editDocModal.docId}/`,
//         formData,
//         {
//           headers: {
//             "Content-Type": "multipart/form-data",
//           },
//         }
//       );
//       showSnackbar("Document uploaded and submitted successfully", "success");
//       setEditDocModal({ open: false, docId: null, claimId: null, file: null, uploading: false });
      
//       // Refresh additional docs
//       const docs = await fetchAdditionalDocs(editDocModal.claimId);
//       setAdditionalDocsModal((prev) => ({ ...prev, docs }));
      
//       // Refresh claims table
//       fetchClaims();
//     } catch (err) {
//       console.error("submitDoc", err);
//       showSnackbar("Failed to upload document", "error");
//       setEditDocModal((prev) => ({ ...prev, uploading: false }));
//     }
//   };

//   const columns = [
//     { id: "slNo", field: "slNo", headerName: t("claimList.slNo"), width: 70 },
//     {
//       id: "claimant_name",
//       field: "claimant_name",
//       headerName: t("claimList.claimantName"),
//       width: 220,
//     },
//     { id: "ack_no", field: "ack_no", headerName: t("claimList.ackNo"), width: 260 },
//     {
//       id: "created",
//       field: "created",
//       headerName: t("claimList.appliedDate"),
//       width: 150,
//     },
//     {
//       id: "status",
//       field: "status",
//       headerName: t("claimList.status"),
//       width: 140,
//       renderCell: (params) => (
//         <Chip
//           label={params.value}
//           color={getStatusColor(params.value)}
//           variant="outlined"
//           size="small"
//         />
//       ),
//     },
//     {
//       id: "additional_docs",
//       field: "additional_docs",
//       headerName: "Additional Docs",
//       width: 160,
//       renderCell: (params) => {
//         const hasDocs = params.row.additionalDocsData?.length > 0;
//         return hasDocs ? (
//           <Box 
//             display="flex" 
//             alignItems="center" 
//             gap={0.5}
//             sx={{ 
//               cursor: "pointer",
//               "&:hover": {
//                 opacity: 0.8,
//               }
//             }}
//             onClick={() => handleAdditionalDocsClick(params.row.id)}
//           >
//             <IconButton
//               color="error"
//               size="small"
//               sx={{ p: 0.25 }}
//             >
//               <ErrorIcon fontSize="small" />
//             </IconButton>
//             <Typography 
//               variant="body2" 
//               color="error.main" 
//               fontWeight={500}
//               sx={{ 
//                 cursor: "pointer",
//                 userSelect: "none"
//               }}
//             >
//               Upload Docs
//             </Typography>
//           </Box>
//         ) : (
//           <Typography variant="body2" color="textSecondary">
//             Not applicable
//           </Typography>
//         );
//       },
//     },
//     {
//       id: "actions",
//       field: "actions",
//       headerName: t("claimList.actions"),
//       width: 100,
//       renderCell: (params) => (
//         <IconButton
//           color="primary"
//           onClick={() => setSelectedClaimId(params.row.id)}
//         >
//           <Visibility />
//         </IconButton>
//       ),
//     },
//   ];

//   // When user clicks "Add Claim"
//   if (showForm) {
//     return (
//       <Box sx={{ p: 3 }}>
//         <Button
//           variant="contained"
//           onClick={() => setShowForm(false)}
//           sx={{ mb: 2 }}
//         >
//           {t("claimList.backToClaims")}
//         </Button>
//         <ClaimFormPage
//           onSuccess={(ack_no) => {
//             setShowForm(false);
//             setSuccessModal({
//               open: true,
//               ack_no: ack_no || t("claimList.na"),
//               message: t("claimList.claimSubmitSuccess"),
//             });
//             fetchClaims();
//           }}
//         />
//       </Box>
//     );
//   }

//   // When user clicks "View Claim"
//   if (selectedClaimId) {
//     return (
//       <Box sx={{ p: 3 }}>
//         <Button
//           variant="contained"
//           onClick={() => setSelectedClaimId(null)}
//           sx={{ mb: 2 }}
//         >
//           {t("claimList.backToClaims")}
//         </Button>
//         <ClaimDetailPage pk={selectedClaimId} claim_url={"claims"} />
//       </Box>
//     );
//   }

//   // Modal UI for Success
//   const handlePrint = () => window.print();

//   return (
//     <Box sx={{ p: 3 }}>
//       <Box display="flex" justifyContent="space-between" alignItems="center" mb={2}>
//         <Typography variant="h4">{t("claimList.myClaims")}</Typography>
//         <Button variant="contained" onClick={() => setShowForm(true)}>
//           {t("claimList.newClaim")}
//         </Button>
//       </Box>

//       {loading ? (
//         <LoadingSpinner />
//       ) : (
//         <TableComponent
//           rows={rows}
//           columns={columns}
//           manageColumnStatus
//           enableSort="true"
//         />
//       )}

//       {/* Additional Docs Modal */}
//       <Modal
//         open={additionalDocsModal.open}
//         onClose={() => setAdditionalDocsModal({ open: false, claimId: null, docs: [] })}
//       >
//         <Box
//           sx={{
//             position: "absolute",
//             top: "50%",
//             left: "50%",
//             transform: "translate(-50%, -50%)",
//             width: 500,
//             maxHeight: "80vh",
//             bgcolor: "background.paper",
//             borderRadius: 3,
//             boxShadow: 24,
//             p: 4,
//             overflowY: "auto",
//           }}
//         >
//           <Box display="flex" justifyContent="space-between" alignItems="center" mb={2}>
//             <Typography variant="h6">
//               Additional Documents Required
//             </Typography>
//             <IconButton
//               onClick={() => setAdditionalDocsModal({ open: false, claimId: null, docs: [] })}
//               size="small"
//             >
//               <CloseIcon />
//             </IconButton>
//           </Box>
//           {additionalDocsModal.loading ? (
//             <LoadingSpinner />
//           ) : (
//             <List>
//               {additionalDocsModal.docs.map((doc) => (
//                 <ListItem key={doc.id} divider>
//                   <ListItemText
//                     primary={doc.name || "Document"}
//                     secondary={
//                       doc.document && doc.is_submited 
//                         ? `Uploaded: ${doc.document.split('/').pop()}` 
//                         : doc.is_submited 
//                         ? "Submitted" 
//                         : "Pending"
//                     }
//                   />
//                   <ListItemSecondaryAction>
//                     <IconButton
//                       edge="end"
//                       onClick={() => handleEditDoc(doc.id, additionalDocsModal.claimId)}
//                       disabled={doc.is_submited}
//                     >
//                       <UploadIcon />
//                     </IconButton>
//                   </ListItemSecondaryAction>
//                 </ListItem>
//               ))}
//             </List>
//           )}
//         </Box>
//       </Modal>

//       {/* Edit Document Modal */}
//       <Modal
//         open={editDocModal.open}
//         onClose={() => setEditDocModal({ open: false, docId: null, claimId: null, file: null, uploading: false })}
//       >
//         <Box
//           sx={{
//             position: "absolute",
//             top: "50%",
//             left: "50%",
//             transform: "translate(-50%, -50%)",
//             width: 400,
//             bgcolor: "background.paper",
//             borderRadius: 3,
//             boxShadow: 24,
//             p: 4,
//           }}
//         >
//           <Box display="flex" justifyContent="space-between" alignItems="center" mb={2}>
//             <Typography variant="h6">Upload Document</Typography>
//             <IconButton
//               onClick={() => setEditDocModal({ open: false, docId: null, claimId: null, file: null, uploading: false })}
//               size="small"
//               disabled={editDocModal.uploading}
//             >
//               <CloseIcon />
//             </IconButton>
//           </Box>
          
//           {editDocModal.uploading ? (
//             <Box display="flex" flexDirection="column" alignItems="center" gap={2} p={3}>
//               <CircularProgress />
//               <Typography>Uploading document...</Typography>
//             </Box>
//           ) : (
//             <>
//               <TextField
//                 fullWidth
//                 type="file"
//                 onChange={handleFileChange}
//                 inputProps={{ 
//                   accept: ".pdf,.doc,.docx,.jpg,.jpeg,.png",
//                   multiple: false 
//                 }}
//                 sx={{ mb: 3 }}
//               />
//               {editDocModal.file && (
//                 <Typography variant="body2" color="success.main" sx={{ mb: 2 }}>
//                   Selected: {editDocModal.file.name} ({(editDocModal.file.size / 1024 / 1024).toFixed(2)} MB)
//                 </Typography>
//               )}
//               <Box display="flex" justifyContent="flex-end" gap={2}>
//                 <Button
//                   onClick={() => setEditDocModal({ open: false, docId: null, claimId: null, file: null, uploading: false })}
//                 >
//                   Cancel
//                 </Button>
//                 <Button 
//                   variant="contained" 
//                   onClick={handleSubmitDoc}
//                   disabled={!editDocModal.file || editDocModal.uploading}
//                 >
//                   Submit Document
//                 </Button>
//               </Box>
//             </>
//           )}
//         </Box>
//       </Modal>

//       {/* Confirm Submit Modal */}
//       <Dialog
//         open={confirmSubmitModal.open}
//         onClose={() => setConfirmSubmitModal({ open: false, docId: null, claimId: null })}
//       >
//         <DialogTitle>
//           Confirm Document Submission
//           <IconButton
//             aria-label="close"
//             onClick={() => setConfirmSubmitModal({ open: false, docId: null, claimId: null })}
//             sx={{
//               position: 'absolute',
//               right: 8,
//               top: 8,
//               color: (theme) => theme.palette.grey[500],
//             }}
//           >
//             <CloseIcon />
//           </IconButton>
//         </DialogTitle>
//         <DialogContent>
//           <DialogContentText>
//             Are you sure you want to upload and submit this document? 
//             <br />
//             <strong>File:</strong> {editDocModal.file?.name}
//             <br />
//             This action cannot be undone.
//           </DialogContentText>
//         </DialogContent>
//         <DialogActions>
//           <Button
//             onClick={() => setConfirmSubmitModal({ open: false, docId: null, claimId: null })}
//           >
//             Cancel
//           </Button>
//           <Button onClick={confirmSubmit} variant="contained" color="primary">
//             Confirm & Upload
//           </Button>
//         </DialogActions>
//       </Dialog>

//       <SnackBarComponent
//         open={snackbar.open}
//         message={snackbar.message}
//         severity={snackbar.severity}
//         onClose={closeSnackbar}
//       />

//       {/* Success Modal */}
//       <Modal
//         open={successModal.open}
//         onClose={() => setSuccessModal({ ...successModal, open: false })}
//       >
//         <Box
//           sx={{
//             backgroundColor: "white",
//             p: 5,
//             borderRadius: 3,
//             textAlign: "center",
//             maxWidth: 400,
//             mx: "auto",
//             mt: "15%",
//             boxShadow: 5,
//           }}
//         >
//           <CheckCircleOutline color="success" sx={{ fontSize: 64, mb: 2 }} />
//           <Typography variant="h5" sx={{ mb: 1 }}>
//             {t("claimList.congratulations")}
//           </Typography>
//           <Typography variant="body1" sx={{ mb: 2 }}>
//             {successModal.message}
//           </Typography>
//           <Typography variant="subtitle1" sx={{ fontWeight: "bold", mb: 3 }}>
//             {t("claimList.ackNo")}: {successModal.ack_no}
//           </Typography>
//           <Button variant="contained" onClick={handlePrint} sx={{ mr: 1 }}>
//             {t("claimList.print")}
//           </Button>
//           <Button
//             variant="outlined"
//             onClick={() => setSuccessModal({ ...successModal, open: false })}
//           >
//             {t("claimList.close")}
//           </Button>
//         </Box>
//       </Modal>
//     </Box>
//   );
// }



import React, { useEffect, useState } from "react";
import {
  Box,
  Typography,
  Button,
  IconButton,
  Chip,
  Modal,
  List,
  ListItem,
  ListItemText,
  ListItemSecondaryAction,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  TextField,
  CircularProgress,
  Paper,
  Avatar,
} from "@mui/material";
import {
  Visibility,
  CheckCircleOutline,
  Upload as UploadIcon,
  Close as CloseIcon,
  Error as ErrorIcon,
  Add as AddIcon,
  Assignment as AssignmentIcon,
} from "@mui/icons-material";
import api from "../../api/axiosInterceptor";
import { API_BASE_URL } from "../../config";
import TableComponent from "../../Components/TableComponent/TableComponent";
import { LoadingSpinner } from "../../Components/spinner/spinner";
import { SnackBarComponent } from "../../Components/snackBar/snackBar";
import ClaimFormPage from "./claimForm";
import ClaimDetailPage from "./claimView";
import { useTranslation } from "react-i18next";

// Status config
const STATUS_CONFIG = {
  Rejected:    { color: "error",   bg: "#fef2f2", text: "#dc2626", border: "#fca5a5" },
  "CA Verified":{ color: "success", bg: "#f0fdf4", text: "#16a34a", border: "#86efac" },
  "In Progress":{ color: "warning", bg: "#fffbeb", text: "#d97706", border: "#fcd34d" },
  Submitted:   { color: "info",    bg: "#eff6ff", text: "#2563eb", border: "#93c5fd" },
  Settled:     { color: "success", bg: "#f0fdf4", text: "#16a34a", border: "#86efac" },
  Draft:       { color: "default", bg: "#f8fafc", text: "#64748b", border: "#cbd5e1" },
};

const modalBoxSx = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  bgcolor: "#fff",
  borderRadius: "20px",
  boxShadow: "0 24px 80px rgba(0,0,0,0.15)",
  p: 4,
  outline: "none",
};

export default function ClaimListPage() {
  const { t } = useTranslation();
  const [rows, setRows] = useState([]);
  const [loading, setLoading] = useState(true);
  const [snackbar, setSnackbar] = useState({ open: false, message: "", severity: "info" });
  const [showForm, setShowForm] = useState(false);
  const [selectedClaimId, setSelectedClaimId] = useState(null);
  const [additionalDocsModal, setAdditionalDocsModal] = useState({ open: false, claimId: null, docs: [], loading: false });
  const [editDocModal, setEditDocModal] = useState({ open: false, docId: null, claimId: null, file: null, uploading: false });
  const [confirmSubmitModal, setConfirmSubmitModal] = useState({ open: false, docId: null, claimId: null });
  const [successModal, setSuccessModal] = useState({ open: false, ack_no: "", message: "" });

  const showSnackbar = (msg, sev = "info") => setSnackbar({ open: true, message: msg, severity: sev });
  const closeSnackbar = () => setSnackbar((p) => ({ ...p, open: false }));

  const fetchClaims = async () => {
    setLoading(true);
    try {
      const res = await api.get(`/claim-mgmt/claims/`);
      const data = await Promise.all(
        res.data.map(async (item, idx) => {
          const csb = Array.isArray(item.claim_status_base) ? item.claim_status_base[0] : item.claim_status_base;
          const status = csb
            ? csb.is_rejected ? "Rejected"
            : csb.is_settled ? "Settled"
            : csb.is_ca_verified ? "CA Verified"
            : csb.is_verified_2 || csb.is_verified_1 ? "In Progress"
            : csb.is_submited ? "Submitted" : "Draft"
            : "Unknown";

          let additionalDocsData = [];
          try {
            const docsRes = await api.get(`/claim-mgmt/additional-docs/${item.id}/`);
            additionalDocsData = docsRes.data || [];
          } catch {}

          return {
            id: item.id,
            slNo: idx + 1,
            claimant_name:
              item.claiment_type === "self" ? item.name_of_claimant1 || "-"
              : item.claiment_type === "nominee" ? item.nominee?.[0]?.name || "-"
              : item.claiment_type === "legal_heir" ? item.legalHeir?.[0]?.name || "-"
              : item.name_of_claimant1 || "-",
            ack_no: item.ack_no || "-",
            created: item.created ? new Date(item.created).toLocaleDateString("en-GB") : "-",
            status,
            additionalDocsData,
            fullData: item,
          };
        })
      );
      setRows(data);
    } catch {
      showSnackbar(t("claimList.fetchError"), "error");
    } finally {
      setLoading(false);
    }
  };

  const fetchAdditionalDocs = async (claimId) => {
    try {
      const res = await api.get(`/claim-mgmt/additional-docs/${claimId}/`);
      return res.data || [];
    } catch { return []; }
  };

  useEffect(() => { fetchClaims(); }, []);

  const handleAdditionalDocsClick = async (claimId) => {
    setAdditionalDocsModal((p) => ({ ...p, loading: true, claimId }));
    const docs = await fetchAdditionalDocs(claimId);
    setAdditionalDocsModal({ open: true, claimId, docs, loading: false });
  };

  const handleFileChange = (e) => setEditDocModal((p) => ({ ...p, file: e.target.files[0] }));

  const handleSubmitDoc = async () => {
    if (!editDocModal.file) { showSnackbar("Please select a file", "warning"); return; }
    setConfirmSubmitModal({ open: true, docId: editDocModal.docId, claimId: editDocModal.claimId });
  };

  const confirmSubmit = async () => {
    setConfirmSubmitModal({ open: false, docId: null, claimId: null });
    setEditDocModal((p) => ({ ...p, uploading: true }));
    const formData = new FormData();
    formData.append("document", editDocModal.file);
    formData.append("is_submited", true);
    try {
      await api.patch(`/claim-mgmt/additional-docs/${editDocModal.claimId}/${editDocModal.docId}/`, formData, { headers: { "Content-Type": "multipart/form-data" } });
      showSnackbar("Document uploaded successfully", "success");
      setEditDocModal({ open: false, docId: null, claimId: null, file: null, uploading: false });
      const docs = await fetchAdditionalDocs(editDocModal.claimId);
      setAdditionalDocsModal((p) => ({ ...p, docs }));
      fetchClaims();
    } catch {
      showSnackbar("Failed to upload document", "error");
      setEditDocModal((p) => ({ ...p, uploading: false }));
    }
  };

  const columns = [
    { id: "slNo", field: "slNo", headerName: "SL No", width: 60 },
    { id: "claimant_name", field: "claimant_name", headerName: t("claimList.claimantName"), width: 220 },
    { id: "ack_no", field: "ack_no", headerName: t("claimList.ackNo"), width: 260 },
    { id: "created", field: "created", headerName: t("claimList.appliedDate"), width: 140 },
    {
      id: "status", field: "status", headerName: t("claimList.status"), width: 140,
      renderCell: (params) => {
        const cfg = STATUS_CONFIG[params.value] || STATUS_CONFIG.Draft;
        return (
          <Chip
            label={params.value}
            size="small"
            sx={{
              background: cfg.bg,
              color: cfg.text,
              border: `1px solid ${cfg.border}`,
              fontWeight: 700,
              fontFamily: "'DM Sans', sans-serif",
              fontSize: "0.75rem",
              borderRadius: "8px",
            }}
          />
        );
      },
    },
    {
      id: "additional_docs", field: "additional_docs", headerName: "Additional Docs", width: 170,
      renderCell: (params) => {
        const hasDocs = params.row.additionalDocsData?.length > 0;
        return hasDocs ? (
          <Box
            sx={{ display: "flex", alignItems: "center", gap: 0.75, cursor: "pointer", "&:hover": { opacity: 0.8 } }}
            onClick={() => handleAdditionalDocsClick(params.row.id)}
          >
            <Box sx={{ width: 8, height: 8, borderRadius: "50%", background: "#ef4444", flexShrink: 0, boxShadow: "0 0 6px rgba(239,68,68,0.6)" }} />
            <Typography variant="body2" sx={{ color: "#dc2626", fontWeight: 700, fontFamily: "'DM Sans', sans-serif", fontSize: "0.82rem" }}>
              Upload Required
            </Typography>
          </Box>
        ) : (
          <Typography variant="body2" sx={{ color: "#94a3b8", fontFamily: "'DM Sans', sans-serif", fontSize: "0.82rem" }}>
            — Not required
          </Typography>
        );
      },
    },
    {
      id: "actions", field: "actions", headerName: t("claimList.actions"), width: 90,
      renderCell: (params) => (
        <IconButton
          size="small"
          onClick={() => setSelectedClaimId(params.row.id)}
          sx={{
            background: "linear-gradient(135deg, #eff6ff, #dbeafe)",
            border: "1px solid #bfdbfe",
            "&:hover": { background: "linear-gradient(135deg, #dbeafe, #bfdbfe)", transform: "scale(1.1)" },
            transition: "all 0.2s",
          }}
        >
          <Visibility sx={{ color: "#2563eb", fontSize: 18 }} />
        </IconButton>
      ),
    },
  ];

  if (showForm) {
    return (
      <Box sx={{ p: 3 }}>
        <Button
          variant="outlined"
          onClick={() => setShowForm(false)}
          sx={{ mb: 2, borderRadius: "10px", fontFamily: "'DM Sans', sans-serif", fontWeight: 600 }}
        >
          ← {t("claimList.backToClaims")}
        </Button>
        <ClaimFormPage
          onSuccess={(ack_no) => {
            setShowForm(false);
            setSuccessModal({ open: true, ack_no: ack_no || t("claimList.na"), message: t("claimList.claimSubmitSuccess") });
            fetchClaims();
          }}
        />
      </Box>
    );
  }

  if (selectedClaimId) {
    return (
      <Box sx={{ p: 3 }}>
        <Button
          variant="outlined"
          onClick={() => setSelectedClaimId(null)}
          sx={{ mb: 2, borderRadius: "10px", fontFamily: "'DM Sans', sans-serif", fontWeight: 600 }}
        >
          ← {t("claimList.backToClaims")}
        </Button>
        <ClaimDetailPage pk={selectedClaimId} claim_url={"claims"} />
      </Box>
    );
  }

  return (
    <Box sx={{ p: 3 }}>
      {/* Page Header */}
      <Box
        sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          mb: 3,
          flexWrap: "wrap",
          gap: 2,
        }}
      >
        <Box>
          <Typography
            variant="h4"
            sx={{
              fontWeight: 800,
              fontFamily: "'DM Sans', sans-serif",
              background: "linear-gradient(135deg, #1e293b 0%, #3b82f6 100%)",
              WebkitBackgroundClip: "text",
              WebkitTextFillColor: "transparent",
            }}
          >
            {t("claimList.myClaims")}
          </Typography>
          <Typography sx={{ color: "#94a3b8", fontSize: "0.85rem", fontFamily: "'DM Sans', sans-serif", mt: 0.25 }}>
            {rows.length} claim{rows.length !== 1 ? "s" : ""} on record
          </Typography>
        </Box>
        <Button
          variant="contained"
          startIcon={<AddIcon />}
          onClick={() => setShowForm(true)}
          sx={{
            borderRadius: "12px",
            background: "linear-gradient(135deg, #3b82f6 0%, #8b5cf6 100%)",
            fontWeight: 700,
            fontFamily: "'DM Sans', sans-serif",
            px: 3,
            py: 1.25,
            boxShadow: "0 4px 20px rgba(59,130,246,0.35)",
            textTransform: "none",
            fontSize: "0.95rem",
            "&:hover": { background: "linear-gradient(135deg, #2563eb 0%, #7c3aed 100%)", transform: "translateY(-1px)", boxShadow: "0 8px 28px rgba(59,130,246,0.45)" },
            transition: "all 0.25s ease",
          }}
        >
          {t("claimList.newClaim")}
        </Button>
      </Box>

      {loading ? <LoadingSpinner /> : (
        <TableComponent rows={rows} columns={columns} manageColumnStatus enableSort="true" />
      )}

      {/* Additional Docs Modal */}
      <Modal open={additionalDocsModal.open} onClose={() => setAdditionalDocsModal({ open: false, claimId: null, docs: [] })}>
        <Box sx={{ ...modalBoxSx, width: 520, maxHeight: "80vh", overflowY: "auto" }}>
          <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center", mb: 3 }}>
            <Box>
              <Typography sx={{ fontWeight: 800, fontSize: "1.1rem", fontFamily: "'DM Sans', sans-serif", color: "#1e293b" }}>
                Additional Documents
              </Typography>
              <Typography sx={{ fontSize: "0.8rem", color: "#94a3b8", fontFamily: "'DM Sans', sans-serif" }}>
                Upload the required documents below
              </Typography>
            </Box>
            <IconButton onClick={() => setAdditionalDocsModal({ open: false, claimId: null, docs: [] })} size="small" sx={{ background: "#f1f5f9", "&:hover": { background: "#e2e8f0" } }}>
              <CloseIcon fontSize="small" />
            </IconButton>
          </Box>
          {additionalDocsModal.loading ? <LoadingSpinner /> : (
            <List sx={{ p: 0 }}>
              {additionalDocsModal.docs.map((doc) => (
                <ListItem
                  key={doc.id}
                  sx={{
                    mb: 1.5,
                    border: doc.is_submited ? "1.5px solid #86efac" : "1.5px solid #fcd34d",
                    borderRadius: "14px",
                    background: doc.is_submited ? "#f0fdf4" : "#fffbeb",
                    px: 2.5,
                  }}
                >
                  <Box sx={{ width: 32, height: 32, borderRadius: "10px", background: doc.is_submited ? "linear-gradient(135deg,#10b981,#059669)" : "linear-gradient(135deg,#f59e0b,#d97706)", display: "flex", alignItems: "center", justifyContent: "center", mr: 2, flexShrink: 0 }}>
                    {doc.is_submited ? <CheckCircleOutline sx={{ color: "#fff", fontSize: 18 }} /> : <AssignmentIcon sx={{ color: "#fff", fontSize: 18 }} />}
                  </Box>
                  <ListItemText
                    primary={<Typography sx={{ fontWeight: 700, fontFamily: "'DM Sans', sans-serif", fontSize: "0.9rem", color: "#1e293b" }}>{doc.name || "Document"}</Typography>}
                    secondary={
                      <Typography sx={{ fontSize: "0.75rem", color: doc.is_submited ? "#065f46" : "#92400e", fontFamily: "'DM Sans', sans-serif", fontWeight: 600 }}>
                        {doc.document && doc.is_submited ? `Uploaded: ${doc.document.split("/").pop()}` : doc.is_submited ? "Submitted" : "⚠️ Pending Upload"}
                      </Typography>
                    }
                  />
                  <ListItemSecondaryAction>
                    <IconButton
                      edge="end"
                      onClick={() => setEditDocModal({ open: true, docId: doc.id, claimId: additionalDocsModal.claimId, file: null, uploading: false })}
                      disabled={doc.is_submited}
                      sx={{
                        background: doc.is_submited ? "#e2e8f0" : "linear-gradient(135deg, #3b82f6, #2563eb)",
                        color: "#fff",
                        "&:hover": { background: doc.is_submited ? "#e2e8f0" : "linear-gradient(135deg, #2563eb, #1d4ed8)" },
                        width: 36, height: 36,
                      }}
                    >
                      <UploadIcon fontSize="small" />
                    </IconButton>
                  </ListItemSecondaryAction>
                </ListItem>
              ))}
            </List>
          )}
        </Box>
      </Modal>

      {/* Edit Document Modal */}
      <Modal open={editDocModal.open} onClose={() => setEditDocModal({ open: false, docId: null, claimId: null, file: null, uploading: false })}>
        <Box sx={{ ...modalBoxSx, width: 420 }}>
          <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center", mb: 3 }}>
            <Typography sx={{ fontWeight: 800, fontSize: "1.1rem", fontFamily: "'DM Sans', sans-serif", color: "#1e293b" }}>Upload Document</Typography>
            <IconButton onClick={() => setEditDocModal({ open: false, docId: null, claimId: null, file: null, uploading: false })} size="small" disabled={editDocModal.uploading} sx={{ background: "#f1f5f9" }}>
              <CloseIcon fontSize="small" />
            </IconButton>
          </Box>
          {editDocModal.uploading ? (
            <Box sx={{ textAlign: "center", py: 4 }}>
              <CircularProgress sx={{ color: "#3b82f6", mb: 2 }} />
              <Typography sx={{ fontFamily: "'DM Sans', sans-serif", color: "#64748b", fontWeight: 600 }}>Uploading document…</Typography>
            </Box>
          ) : (
            <>
              <Box
                sx={{
                  border: editDocModal.file ? "2px solid #10b981" : "2px dashed #cbd5e1",
                  borderRadius: "14px",
                  p: 3,
                  textAlign: "center",
                  background: editDocModal.file ? "#f0fdf4" : "#f8fafc",
                  mb: 3,
                  cursor: "pointer",
                  transition: "all 0.2s",
                  "&:hover": { borderColor: "#3b82f6", background: "#eff6ff" },
                }}
              >
                <input
                  type="file"
                  id="doc-upload"
                  accept=".pdf,.doc,.docx,.jpg,.jpeg,.png"
                  style={{ display: "none" }}
                  onChange={handleFileChange}
                />
                <label htmlFor="doc-upload" style={{ cursor: "pointer", display: "block" }}>
                  {editDocModal.file ? (
                    <>
                      <CheckCircleOutline sx={{ color: "#10b981", fontSize: 36, mb: 1 }} />
                      <Typography sx={{ fontWeight: 700, color: "#065f46", fontFamily: "'DM Sans', sans-serif", fontSize: "0.9rem" }}>{editDocModal.file.name}</Typography>
                      <Typography sx={{ color: "#6ee7b7", fontSize: "0.75rem", mt: 0.25 }}>{(editDocModal.file.size / 1024 / 1024).toFixed(2)} MB</Typography>
                    </>
                  ) : (
                    <>
                      <UploadIcon sx={{ color: "#94a3b8", fontSize: 36, mb: 1 }} />
                      <Typography sx={{ fontWeight: 700, color: "#475569", fontFamily: "'DM Sans', sans-serif", fontSize: "0.9rem" }}>Click to select file</Typography>
                      <Typography sx={{ color: "#94a3b8", fontSize: "0.75rem", mt: 0.25 }}>PDF, DOC, JPG, PNG</Typography>
                    </>
                  )}
                </label>
              </Box>
              <Box sx={{ display: "flex", gap: 1.5 }}>
                <Button
                  fullWidth
                  onClick={() => setEditDocModal({ open: false, docId: null, claimId: null, file: null, uploading: false })}
                  sx={{ borderRadius: "10px", fontFamily: "'DM Sans', sans-serif", fontWeight: 600, color: "#64748b", border: "1.5px solid #e2e8f0" }}
                >
                  Cancel
                </Button>
                <Button
                  fullWidth
                  variant="contained"
                  onClick={handleSubmitDoc}
                  disabled={!editDocModal.file}
                  sx={{
                    borderRadius: "10px",
                    background: "linear-gradient(135deg, #3b82f6, #2563eb)",
                    fontFamily: "'DM Sans', sans-serif",
                    fontWeight: 700,
                    "&.Mui-disabled": { background: "#e2e8f0", color: "#94a3b8" },
                  }}
                >
                  Submit Document
                </Button>
              </Box>
            </>
          )}
        </Box>
      </Modal>

      {/* Confirm Submit */}
      <Dialog open={confirmSubmitModal.open} onClose={() => setConfirmSubmitModal({ open: false, docId: null, claimId: null })} PaperProps={{ sx: { borderRadius: "20px", p: 1 } }}>
        <DialogTitle sx={{ fontWeight: 800, fontFamily: "'DM Sans', sans-serif" }}>Confirm Submission</DialogTitle>
        <DialogContent>
          <DialogContentText sx={{ fontFamily: "'DM Sans', sans-serif", color: "#475569" }}>
            Are you sure you want to submit <strong>{editDocModal.file?.name}</strong>? This action cannot be undone.
          </DialogContentText>
        </DialogContent>
        <DialogActions sx={{ p: 2, gap: 1 }}>
          <Button onClick={() => setConfirmSubmitModal({ open: false, docId: null, claimId: null })} sx={{ borderRadius: "10px", fontFamily: "'DM Sans', sans-serif", fontWeight: 600, color: "#64748b" }}>
            Cancel
          </Button>
          <Button onClick={confirmSubmit} variant="contained" sx={{ borderRadius: "10px", background: "linear-gradient(135deg, #3b82f6, #2563eb)", fontFamily: "'DM Sans', sans-serif", fontWeight: 700 }}>
            Confirm & Upload
          </Button>
        </DialogActions>
      </Dialog>

      <SnackBarComponent open={snackbar.open} message={snackbar.message} severity={snackbar.severity} onClose={closeSnackbar} />

      {/* Success Modal */}
      <Modal open={successModal.open} onClose={() => setSuccessModal((p) => ({ ...p, open: false }))}>
        <Box sx={{ ...modalBoxSx, width: 440, textAlign: "center" }}>
          <Box
            sx={{
              width: 80,
              height: 80,
              borderRadius: "24px",
              background: "linear-gradient(135deg, #10b981, #059669)",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              mx: "auto",
              mb: 3,
              boxShadow: "0 12px 36px rgba(16,185,129,0.4)",
            }}
          >
            <CheckCircleOutline sx={{ color: "#fff", fontSize: 44 }} />
          </Box>
          <Typography variant="h5" sx={{ fontWeight: 800, fontFamily: "'DM Sans', sans-serif", color: "#1e293b", mb: 1 }}>
            {t("claimList.congratulations")}
          </Typography>
          <Typography sx={{ color: "#64748b", fontFamily: "'DM Sans', sans-serif", mb: 2 }}>{successModal.message}</Typography>
          <Box
            sx={{
              background: "linear-gradient(135deg, #f0fdf4, #dcfce7)",
              border: "1.5px solid #86efac",
              borderRadius: "14px",
              py: 2,
              px: 3,
              mb: 3,
            }}
          >
            <Typography sx={{ fontSize: "0.8rem", color: "#6b7280", fontFamily: "'DM Sans', sans-serif", mb: 0.25 }}>Acknowledgment Number</Typography>
            <Typography sx={{ fontWeight: 900, color: "#059669", fontFamily: "monospace", fontSize: "1.1rem", letterSpacing: "0.05em" }}>
              {successModal.ack_no}
            </Typography>
          </Box>
          <Box sx={{ display: "flex", gap: 1.5 }}>
            <Button
              fullWidth
              variant="outlined"
              onClick={() => window.print()}
              sx={{ borderRadius: "12px", fontFamily: "'DM Sans', sans-serif", fontWeight: 700, borderColor: "#e2e8f0", color: "#475569" }}
            >
              🖨 {t("claimList.print")}
            </Button>
            <Button
              fullWidth
              variant="contained"
              onClick={() => setSuccessModal((p) => ({ ...p, open: false }))}
              sx={{ borderRadius: "12px", background: "linear-gradient(135deg, #3b82f6, #8b5cf6)", fontFamily: "'DM Sans', sans-serif", fontWeight: 700 }}
            >
              {t("claimList.close")}
            </Button>
          </Box>
        </Box>
      </Modal>
    </Box>
  );
}